// extracted by mini-css-extract-plugin
export default {"rating":"xR-z","numberOfStars":"yR-z","count":"zR-z","barGraphSpacing":"AR-z","barGraph":"BR-z"};